import { createSlice } from "@reduxjs/toolkit";

import { NOTIFICATION_GROUPS } from "@constants";
import { clearStore } from "actions/initialization";

export const initialState = {
  [NOTIFICATION_GROUPS.general]: { ids: [], hash: {} },
  [NOTIFICATION_GROUPS.a11y]: { ids: [], hash: {} },
  [NOTIFICATION_GROUPS.consversionResult]: { ids: [], hash: {} },
  lastDownloadMessageTime: null,
  showDownloadMessage: false,
  collectDomainInfoFunc: null,
  lastProjectFolder: null,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    notificationAdd(state, action) {
      const notification = action.payload;
      const { id, group } = notification;
      state[group || NOTIFICATION_GROUPS.general].ids.push(id);
      state[group || NOTIFICATION_GROUPS.general].hash[id] = notification;
    },
    notificationDelete(state, action) {
      const { id, group = NOTIFICATION_GROUPS.general } = action.payload;
      if (group && state[group]) {
        if (state[group].hash[id]) {
          delete state[group].hash[id];
        }
        state[group].ids = state[group].ids.filter((_id) => _id !== id);
      }
    },
    setNotificationProjectFolder(state, action) {
      const { id } = action.payload;
      state.lastProjectFolder = id;
    },
  },
  extraReducers: (builder) => builder.addCase(clearStore, () => initialState),
});

export const actions = notificationSlice.actions;

export default notificationSlice.reducer;
